export default __webpack_public_path__ + "static/media/duckInHand.9af517be.jpg";